import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=97783298&scoped=true&lang=pug"
import script from "./DashboardView.vue?vue&type=script&lang=ts"
export * from "./DashboardView.vue?vue&type=script&lang=ts"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=97783298&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97783298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97783298')) {
      api.createRecord('97783298', component.options)
    } else {
      api.reload('97783298', component.options)
    }
    module.hot.accept("./DashboardView.vue?vue&type=template&id=97783298&scoped=true&lang=pug", function () {
      api.rerender('97783298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/DashboardView.vue"
export default component.exports